export default __webpack_public_path__ + "static/media/total_people.59641db4.svg";